import React from 'react'
import { Button } from 'hhsoig-design-system-core'
import { withDocTitle } from '../../components/withDocTitle'

export const FeedbackConfirmation = () => (
  <React.Fragment>
    <h1>Thank you</h1>
    <p>
      We appreciate your feedback. We will take your comments into consideration
      to improve our complaint process.
    </p>
    <Button
      variation="secondary"
      data-testid="confirm-feedback"
      href="https://oig.hhs.gov/fraud/report-fraud/index.asp"
      className="ds-u-margin-bottom--2 ds-u-margin-top--2"
    >
      Return to HHS-OIG Hotline
    </Button>
  </React.Fragment>
)

export default withDocTitle(FeedbackConfirmation)
